<script>
import {mapState} from 'vuex'


export default {
    data() {
    },

    props: [
    ],


    computed: {
        
    },

    created() {

    },

    mounted() {        
    },

    watch: {
    },

    methods: {

    },
}
</script>
